<template>
  <v-menu
    v-model="menu"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field :label="field.label" v-model="formattedDate" v-on="on">
      </v-text-field>
    </template>
    <v-date-picker
      :label="field.label"
      v-model="date"
      locale="ru"
      :first-day-of-week="1"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateField",
  props: ["entity", "value", "field"],
  data() {
    return {
      menu: false
    };
  },
  computed: {
    date: {
      get() {
        return this.entity[this.field.name];
      },
      set(value) {
        this.entity[this.field.name] = value;
      }
    },
    formattedDate() {
      const date = new Date(this.date);
      return date.toLocaleDateString("ru-RU");
    }
  }
};
</script>

<style scoped></style>
